import React, { useCallback, useMemo, useState } from 'react'
import LuxPlusLandingNavigationContext from './LuxPlusLandingNavigationContext'
import LuxPlusLandingFilterRegistryContext from './LuxPlusLandingFilterRegistryContext'

interface Props {
  navigateToPartnerOffers: () => void
  scrollOffset?: number
  children: React.ReactNode
}

function LuxPlusLandingNavigationProvider({ navigateToPartnerOffers, scrollOffset = 0, children }: Props) {
  const [carouselFilterRegistry, setCarouselFilterRegistry] = useState<Record<string, Array<string>>>({})

  /**
   * Only carousels whose filters we explicitly configure get registered here
   * (currently only LuxPlusFilteredOfferCarousel does). Common carousels like
   * OfferCardCarouselSection support filters but aren't registered until we
   * choose to customise their filter configuration.
   */
  const registerFilterCategories = useCallback((carouselId: string, categories: Array<string>) => {
    setCarouselFilterRegistry(prev => ({ ...prev, [carouselId]: categories }))
  }, [])

  const navigationValue = useMemo(() => ({
    navigateToPartnerOffers,
    registerFilterCategories,
    scrollOffset,
  }), [navigateToPartnerOffers, registerFilterCategories, scrollOffset])

  const hasFilterCategory = useCallback(
    (carouselId: string, category: string) => carouselFilterRegistry[carouselId]?.includes(category) ?? false,
    [carouselFilterRegistry],
  )

  const filterRegistryValue = useMemo(() => ({
    hasFilterCategory,
  }), [hasFilterCategory])

  return (
    <LuxPlusLandingNavigationContext.Provider value={navigationValue}>
      <LuxPlusLandingFilterRegistryContext.Provider value={filterRegistryValue}>
        {children}
      </LuxPlusLandingFilterRegistryContext.Provider>
    </LuxPlusLandingNavigationContext.Provider>
  )
}

export default LuxPlusLandingNavigationProvider
